module.exports = __webpack_public_path__ + "img/omg.0a30f945.png";